
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["waterfall-demo-common","waterfall-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Waterfall__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Waterfall/index.en.md?type=demo')
};